/**
 * Пакет минут: как показывать остаток.
 *
 * Списание посекундное, поэтому в минутах показываем с секундами там,
 * где разница видна клиенту («осталось 2:15»), и целыми — в итогах.
 */

/** «12:05» из миллисекунд; отрицательное — со знаком минус. */
export function formatMinSec(ms: number): string {
  const sign = ms < 0 ? '−' : ''
  const total = Math.floor(Math.abs(ms) / 1000)
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${sign}${m.toLocaleString('ru-RU')}:${String(s).padStart(2, '0')}`
}

/** Целые минуты вниз: «использовано 12 мин» не должно опережать факт. */
export function wholeMinutes(ms: number): number {
  return Math.floor(Math.max(0, ms) / 60_000)
}

/** Доля израсходованного пакета, 0..1 (больше 1 — перерасход). */
export function usedShare(usedMs: number, totalMinutes: number): number {
  if (totalMinutes <= 0) return usedMs > 0 ? 1 : 0
  return usedMs / (totalMinutes * 60_000)
}

export type MinutesLevel = 'ok' | 'warn' | 'danger'

/** Предупреждение на 80% и 95%: клиенту нужно время докупить пакет. */
export function minutesLevel(usedMs: number, totalMinutes: number): MinutesLevel {
  const share = usedShare(usedMs, totalMinutes)
  if (share >= 0.95) return 'danger'
  if (share >= 0.8) return 'warn'
  return 'ok'
}
